// src/utils/badgeVariants.ts

export type AvgRScoreBadgeVariant =
  | 'success'
  | 'attention'
  | 'caution'
  | 'neutral';
export type AvgRScoreCategory = 'High' | 'Moderate' | 'Low' | '';

interface RScoreBadgeInfo {
  variant?: AvgRScoreBadgeVariant;
  label?: AvgRScoreCategory;
}

export const getRScoreBadgeVariant = (value?: string): RScoreBadgeInfo => {
  const num = parseFloat(value ?? '');
  if (isNaN(num)) return { variant: undefined, label: undefined };

  if (num >= 1.0 && num <= 1.66) return { variant: 'caution', label: 'Low' };
  if (num >= 1.67 && num <= 2.33)
    return { variant: 'attention', label: 'Moderate' };
  if (num >= 2.34 && num <= 3.0) return { variant: 'success', label: 'High' };
  return { variant: 'neutral', label: '' };
};
